import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class listKissInvoicesCtrl {
  /* @ngInject */
  constructor($scope, $state, $sessionStorage, logger, $translate, KISS_INVOICE, KissInvoiceSvc, PreInvoicesFilter) {
    this.$scope = $scope;
    this.$state = $state;
    this.$sessionStorage = $sessionStorage;
    this.logger = logger;
    this.$translate = $translate;
    this.KISS_INVOICE = KISS_INVOICE;
    this.KissInvoiceSvc = KissInvoiceSvc;
    this.PreInvoicesFilter = PreInvoicesFilter;
  }

  $onInit() {
    var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
    // ---------------
    // Data API
    // ---------------
    this.transModes = this.KISS_INVOICE.transModes;
    this.functionalStatuses = this.KISS_INVOICE.functionalStatuses;
    this.searchData =
      this.keepSearchData && this.$sessionStorage.listKissInvoicesCriteria
        ? this.$sessionStorage.listKissInvoicesCriteria
        : new this.PreInvoicesFilter();

    this.gridOptions = {
      columnDefs: [
        {
          name: 'seller.getNameForList()',
          displayName: 'kiss_invoice.list.seller',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'buyer.getNameForList()',
          displayName: 'kiss_invoice.list.buyer',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'principal.getNameWithEid()',
          displayName: 'commons.do',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer'
        },
        {
          name: 'getTransMode()',
          displayName: 'kiss_invoice.list.transMode',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 150
        },
        {
          name: 'creationDate',
          displayName: 'kiss_invoice.list.creationDate',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 120,
          cellFilter: "date:'short'"
        },
        {
          name: 'updateDate',
          displayName: 'kiss_invoice.list.updateDate',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 120,
          cellFilter: "date:'short'"
        },
        {
          name: 'getStatus()',
          displayName: 'kiss_invoice.list.status',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 180,
          enableSorting: false
        },
        {
          name: 'refDoc',
          displayName: 'kiss_invoice.list.refDoc',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 150,
          enableSorting: false
        },
        {
          name: 'refKissName',
          displayName: 'kiss_invoice.list.refKiss',
          headerCellFilter: 'translate',
          cellTemplate:
            '<div class="ui-grid-cell-contents">' +
            '<div ng-if="row.entity.isUploadMail()"><a ng-href="{{grid.appScope.$ctrl.viewEdpf(row)}}">{{COL_FIELD}}</a></div>' +
            '<div ng-if="row.entity.isWebInput()"><a ng-href="{{row.entity.getInputXmlLink()}}" target="_blank">{{COL_FIELD}}</a></div></div>',
          cellClass: 'pointer',
          width: 180,
          enableSorting: false
        },
        {
          name: 'techId',
          displayName: 'kiss_invoice.list.techID',
          headerCellFilter: 'translate',
          cellTemplate: defaultCellTemplate,
          cellClass: 'pointer',
          width: 80
        },
        {
          name: 'getPdfLink()',
          displayName: 'kiss_invoice.list.pdf',
          headerCellFilter: 'translate',
          cellTemplate:
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">' +
            '<a ng-if="!row.entity.isDraft()" ng-href="{{COL_FIELD}}" target="_blank">Voir</a></div>',
          cellClass: 'pointer',
          width: 50,
          enableSorting: false
        }
      ],
      exporterOlderExcelCompatibility: true,
      useExternalPagination: true,
      useExternalSorting: true,
      onRegisterApi: gridApi => {
        this.gridApi = gridApi;
        // Sorting & pagination
        gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
          sortColumns = _.map(sortColumns, col => this.convertSort(col));
          if (sortColumns && sortColumns.length > 0) {
            this.searchData.setSort(sortColumns);
          } else {
            this.searchData.resetSort();
          }
          this.search();
        });
        gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
          this.searchData.setPageSize(size);
          this.searchData.setPage(page - 1);
          this.search();
        });
      },
      enableSorting: true,
      enableGridMenu: false,
      enableColumnMenus: false
    };

    this.datePickerCreationMinOpened = false;
    this.datePickerCreationMaxOpened = false;
    this.datePickerUpdateMinOpened = false;
    this.datePickerUpdateMaxOpened = false;

    this.preparedSearchFilter = {};
    this.headers = [];

    this.clearFilter = true;
    //initialiser le filtre de recherche pour l'export
    this.preparedSearchFilter = this.searchData.preparBeforeSearch();

    //recuperer la liste des headers pour l'export
    this.headers = _.map(this.gridOptions.columnDefs, 'displayName');
    this.headers = _.pull(this.headers, 'kiss_invoice.list.techID', 'kiss_invoice.list.pdf');
    this.headers = _.map(this.headers, column => {
      return this.$translate.instant(column);
    });
  }

  convertSort(col) {
    var columnField = _.find(this.KISS_INVOICE.columnFieldMap, { field: col.field });
    if (col && col.sort) {
      return {
        direction: angular.uppercase(col.sort.direction),
        property: columnField ? columnField.property : col.field,
        priority: col.sort.priority
      };
    }
    return {};
  }

  paginationChanged(page, size) {
    this.searchData.setPageSize(size);
    this.searchData.setPage(page - 1);
    this.search();
  }

  search() {
    this.$sessionStorage.listKissInvoicesCriteria = this.searchData;
    this.kissInvoicePromise = this.KissInvoiceSvc.searchPreInvoices(this.searchData);
    this.kissInvoicePromise.then(
      invoicesData => {
        this.gridOptions.data = invoicesData.invoices;
        this.gridOptions.totalItems = invoicesData.totalItems;
        //enregistrer le filtre de recherche formaté pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();
      },
      () => {
        this.logger.error('error.search');
      }
    );
  }

  clearForm() {
    // Reset data
    this.searchData = new this.PreInvoicesFilter();
    // Reset form
    this.form.$setPristine();
    // Recherche
    this.search();
  }

  openDatePickerCreationMin() {
    this.datePickerCreationMinOpened = true;
  }

  openDatePickerCreationMax() {
    this.datePickerCreationMaxOpened = true;
  }

  openDatePickerUpdateMin() {
    this.datePickerUpdateMinOpened = true;
  }

  openDatePickerUpdateMax() {
    this.datePickerUpdateMaxOpened = true;
  }

  viewEdpf(row) {
    let url = '#';
    this.clearFilter = false;
    if (row.entity.batchEpdf) {
      url = this.$state.href('batch_details', { batchId: row.entity.refKissId });
    } else {
      url = this.$state.href('envelope_details', { envelopeId: row.entity.refKissId });
    }
    return url;
  }

  /**
   * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
   */
  getGridHeight() {
    return gridHeight(this.gridApi);
  }
}

angular.module('app.kissinvoice').component('listKissInvoices', {
  templateUrl: require('./list-kiss-invoices.html'),
  controller: listKissInvoicesCtrl,
  bindings: {
    keepSearchData: '<'
  }
});
